import { render, staticRenderFns } from "./add-edit-lr.vue?vue&type=template&id=7a38ec7a&scoped=true&"
import script from "./add-edit-lr.vue?vue&type=script&lang=js&"
export * from "./add-edit-lr.vue?vue&type=script&lang=js&"
import style0 from "./add-edit-lr.vue?vue&type=style&index=0&id=7a38ec7a&scoped=true&lang=css&"
import style1 from "./add-edit-lr.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a38ec7a",
  null
  
)

export default component.exports